import { render, staticRenderFns } from "./DdSelectItemsPerPage.vue?vue&type=template&id=94125ace&scoped=true&"
import script from "./DdSelectItemsPerPage.vue?vue&type=script&lang=js&"
export * from "./DdSelectItemsPerPage.vue?vue&type=script&lang=js&"
import style0 from "./DdSelectItemsPerPage.vue?vue&type=style&index=0&id=94125ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94125ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VRow,VSelect})
